import { render, staticRenderFns } from "./PaymentInterestReports.vue?vue&type=template&id=0c85e67c&scoped=true"
import script from "./PaymentInterestReports.vue?vue&type=script&lang=js"
export * from "./PaymentInterestReports.vue?vue&type=script&lang=js"
import style0 from "./PaymentInterestReports.vue?vue&type=style&index=0&id=0c85e67c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c85e67c",
  null
  
)

export default component.exports